import { localUrl as appLocalUrl } from '../app-path.js';
import slugify from 'slugify';

const FORECAST_PATH_BY_PAGE = {
	agora: 'agora/cidade',
	hoje: 'cidade',
	amanha: 'amanha/cidade',
	fds: 'fim-de-semana/cidade',
	'15dias': '15-dias/cidade',
};

function getCityName(city = {}) {
	return (
		city.cname ||
		city.cityName ||
		city.localeName ||
		city.name ||
		String(city.label || '').split(/\s+-\s+/)[0] ||
		''
	);
}

function getCityUf(city = {}) {
	if (city.uf === 'ND' && city.ac) {
		return city.ac;
	}

	return city.uf || city.stateUf || city.ac || '';
}

export function buildFavoriteCityForecastUrl(city = {}, forecastPage = '') {
	const forecastPath = FORECAST_PATH_BY_PAGE[forecastPage];
	const cityId = city.cid || city.idcity;
	const cityName = getCityName(city);
	const uf = getCityUf(city);

	if (!forecastPath || !cityId || !cityName || !uf) {
		return null;
	}

	const citySlug = slugify(String(cityName)).replace(/-/g, '').toLowerCase();
	return appLocalUrl(`/previsao-do-tempo/${forecastPath}/${cityId}/${citySlug}-${String(
		uf,
	).toLowerCase()}`);
}
